"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FBDMenuSelectOption = void 0;
const FBDMenuOption_1 = require("./FBDMenuOption");
const KHHelperFunctions_1 = require("./KH/KHHelperFunctions");
class FBDMenuSelectOption extends FBDMenuOption_1.FBDMenuOption {
    constructor(prefix, values, descriptions, callback = null, idx = 0) {
        if (descriptions.length != values.length) {
            throw "Descriptions length does not equal values length!";
        }
        prefix = prefix ? prefix.toUpperCase() : "";
        super(prefix + values[idx], descriptions[idx], true, () => {
            this.setSelectedIdx(KHHelperFunctions_1.inRange(this.selected_idx + 1, this.values.length));
        }, () => {
            this.setSelectedIdx(KHHelperFunctions_1.inRange(this.selected_idx - 1, this.values.length));
        });
        this.menu_callback = callback;
        this.values = values;
        this.prefix = prefix;
        this.descriptions = descriptions;
        this.selected_idx = idx;
    }
    lockAt(idx, reason) {
        if (this.locked)
            return;
        this.lockReason = reason;
        this.setSelectedIdx(idx);
        this.locked = true;
    }
    setSelectedIdx(idx, allow_callback = true) {
        if (this.locked)
            return;
        this.selected_idx = idx;
        this.text = (this.prefix + this.values[this.selected_idx]).toUpperCase();
        this.description = this.descriptions[this.selected_idx].toUpperCase();
        if (this.lockReason) {
            this.description += ("\n\n(Locked by " + this.lockReason + ")").toUpperCase();
        }
        this.updateText(this.lockReason != null);
        if (this.menu_callback && allow_callback) {
            this.menu_callback(this.selected_idx);
        }
    }
}
exports.FBDMenuSelectOption = FBDMenuSelectOption;
